import React, { useRef, useState } from 'react';
import { Container, Carousel } from 'react-bootstrap';
import GettingStarted from './GettingStarted';
import KeyFeatures from './KeyFeatures';
import ScoringProcess from './ScoringProcess';
import ScoringMethodology from './ScoringMethodology';
import GetStartedNow from './components/GetStartedNow';
import { config } from '../../../utilities/config';

const ManageCoriolis = () => {
  const maxSelectedIndex = 3;
  const classNames = ['manage-coriolis'];
  const [selectedIndex, setSelectedIndex] = useState(0);
  const modalRef = useRef(null);
  switch (selectedIndex) {
    case 0:
      classNames.push('coriolis-first');
      break;
    case maxSelectedIndex:
      classNames.push('coriolis-last');
      break;
    default:
      break;
  }

  const handleOpenGetStarted = () => {
    window.open(config.CORIOLIS_STARTED_URL, '_blank');
    // @todo disable as requested from diem@simble.io
    // modalRef.current?.openModal();
  };

  return (
    <Container fluid className={classNames.join(' ')}>
      <GetStartedNow ref={modalRef} />
      <Carousel
        className="coriolis-carousel"
        interval={null}
        onSelect={(idx) => setSelectedIndex(idx)}
        indicators={false}
      >
        <Carousel.Item>
          <GettingStarted onGetStarted={handleOpenGetStarted} />
        </Carousel.Item>
        <Carousel.Item>
          <KeyFeatures onGetStarted={handleOpenGetStarted} />
        </Carousel.Item>
        <Carousel.Item>
          <ScoringProcess onGetStarted={handleOpenGetStarted} />
        </Carousel.Item>
        <Carousel.Item>
          <ScoringMethodology onGetStarted={handleOpenGetStarted} />
        </Carousel.Item>
      </Carousel>
      <span className="coriolis-pagination">{selectedIndex + 1}/{maxSelectedIndex + 1}</span>
    </Container>
  );
};

export default ManageCoriolis;